import { useAdvisor } from '#advisor-portal/state/useAdvisor'

const whitelistedRoutes = [
  '/email-redirect',
]

const skippedRoutePrefixes = ['/academy', '/blog']
/**
 * 🔐 1. Advisor Portal Access Restriction:
 * - If portal is disabled, block access to any /advisor-portal route
 * - If portal is enabled but user isn't an advisor, also block access
 * 🔐 2. Project UI Access Restriction:
 * - If portal is enabled and user is an advisor w/o selected project. Block access for Project UI.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  // Create outside components: its queries would make the first reader an SSR async boundary, shifting useId().
  const advisor = useAdvisor()

  // Skip during SSR
  if (import.meta.server) {
    return
  }

  if (skippedRoutePrefixes.some(prefix => to.path.startsWith(prefix))) {
    return
  }

  const auth = useAuth()

  if (to.fullPath.includes('login')) {
    return
  }

  // Don't run advisor logic if user is not logged in
  if (!auth.isLoggedIn) {
    return
  }

  // Skip advisor logic for email redirect page - it needs to process the redirect URL
  if (whitelistedRoutes.includes(to.path)) {
    return
  }

  const isAdvisorWhitelistPage = advisor.isAdvisorWhitelistRouteName(to)
  const isAdvisorPortalPage = to.path.startsWith('/advisor-portal')

  // Prevents non-advisor from accessing advisor portal
  if (!auth.isAdvisor && isAdvisorPortalPage) {
    return navigateTo('/')
  }

  if (auth.isAdvisor && !advisor.isInProject && !(isAdvisorPortalPage || isAdvisorWhitelistPage)) {
    return navigateTo('/advisor-portal')
  }
  // Let the user open the Advisor page
})
